import { Component, inject, OnDestroy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AccountService } from './account/account.service';
import { ModalLayoutComponent } from './ui/modal/modal-layout.component';
import { NotifyQueueComponent } from './ui/notify/notify-queue.component';
import { ThemeService } from './core/theme.service';
import { SettingsService } from './account/settings/settings.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ModalLayoutComponent, NotifyQueueComponent],
  template: `
    <router-outlet />
    <app-modal-layout />
    <app-notify-queue />
  `,
  styles: `
    :host {
      display: flex;
      flex-direction: column;
      align-items: center;
      height: 100%;
      width: 100%;
      background-color: var(--bg-base);
    }
    router-outlet {
      display: contents;
    }
  `,
})
export class AppComponent implements OnDestroy {

  private themeService = inject(ThemeService);
  private settingsService = inject(SettingsService);
  private account = inject(AccountService)

  private sb = this.themeService.theme$.subscribe(theme => document.documentElement.classList.toggle('theme-dark', theme == 'dark'))

  constructor() {
    this.account.loadAccountDetail();
    this.settingsService.loadSettings();
  }

  ngOnDestroy() {
    this.sb.unsubscribe();
  }
}
